import {GLOBAL_ENVIRONMENT} from './global';

export const environment = {
  ...GLOBAL_ENVIRONMENT,
  production: true,
  api: {
    baseUrl: 'https://api-gw.cube.rina.org/admin-tool'
  },
};
